import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { OnboardingTooltip } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './InfrastructureMapYears.css';
import { Year } from './parts/Year';

interface IInfrastructureMapYearsProps {
  selectedYear: number;
  nextAvailableYear: number | null;
  years: number[];
  onChange: (value: number) => void;
  isOnboardingOpen?: boolean;
  onOnboardingClose?: () => void;
  onOnboardingShowing?: () => void;
}

export const InfrastructureMapYears: React.VFC<IInfrastructureMapYearsProps> = ({
  selectedYear,
  nextAvailableYear,
  years,
  onChange,
  isOnboardingOpen = false,
  onOnboardingClose = () => {},
  onOnboardingShowing = () => {},
}) => {
  const onboardingContent = (
    <ActionAfterViewObserver triggerOnce callback={onOnboardingShowing} percentVisible={1}>
      <span>Посмотрите, что появится рядом с ЖК</span>
    </ActionAfterViewObserver>
  );

  return (
    <div className={styles['wrapper']} data-testid="InfrastructureMapYears">
      <OnboardingTooltip
        open={isOnboardingOpen}
        onClose={onOnboardingClose}
        content={onboardingContent}
        placement="bottom-start"
        portal={false}
      >
        <div className={styles['years']}>
          {years.map(year => (
            <Year
              key={year}
              year={year}
              onChange={onChange}
              checked={year === selectedYear}
              nextAvailableYear={nextAvailableYear}
            />
          ))}
        </div>
      </OnboardingTooltip>
    </div>
  );
};
